let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("3iNiV")]).then(() => parcelRequire('7pxIK'));